import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {User} from '../../../../kf-data-entry/models/user.interface';
import {WeeeSystems} from '../../../models/weee_systems.interface';
import {CreateUsersComponent} from '../create-users/create-users.component';
import {EditUsersComponent} from '../edit-users/edit-users.component';
import {Role} from '../../../models/role.interface';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';

@Component({
  selector: 'app-users-table',
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.scss']
})
export class UsersTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['name', 'firstName', 'weeeSystem.description', 'role.name', 'edit'];

  @Input()
  users!: User[];
  @Input()
  roles!: Role[];
  @Input()
  weeeSystems!: WeeeSystems[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadUsers: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  updateUserStatus: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  deleteUser: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  printUsers: EventEmitter<void> = new EventEmitter();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadUsers.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadUsers.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  addUser(): void {
    const dialogRef = this.dialog.open(CreateUsersComponent, {
      data: {weeeSystems: this.weeeSystems, roles: this.roles},
      maxWidth: 600, width: 'inherit'}
    );

    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.loadUsers.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  editUser(value: User): void {
    const dialogRef = this.dialog.open(EditUsersComponent, {
      data: {user: value, weeeSystems: this.weeeSystems, roles: this.roles},
      maxWidth: 600, width: 'inherit'}
    );

    dialogRef.componentInstance.editEvent.subscribe(() => {
      this.loadUsers.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  updateUser(user: User, deleteUser: boolean): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${deleteUser ? 'Delete' : (user.status === 'ACTIVE' ? 'Disable' : 'Enable')} User`,
            text: `Are you sure you want to ${deleteUser ? 'delete' : (user.status === 'ACTIVE' ? 'deactivate' : 'activate')} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe((confirm: boolean) => {
      if (confirm) {
        if (deleteUser) {
          this.deleteUser.emit(user.id);
        }
        else {
          this.updateUserStatus.emit(user.id);
        }
      }
      dialogRef.close();
    });
  }

  print(): void {
    this.printUsers.emit();
  }

}
